var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showMainDetails
        ? _c(
            "form-accordion",
            { attrs: { title: _vm.ServiceDetails } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.rsn"),
                          inputValue: _vm.payment.reason,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.idtfr"),
                          inputValue: _vm.payment.endToEndId,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm.payment.direction === "1"
                    ? [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("common.crdtr_name"),
                                inputValue: _vm.payment.creditorName,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("common.crdtr_mail"),
                                inputValue: _vm.payment.creditorIdentifier,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm.payment.direction === "0"
                    ? [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("common.debtor_name"),
                                inputValue: _vm.payment.debtorName,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("common.debtor_email"),
                                inputValue: _vm.payment.debtorIdentifier,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm._l(
                    _vm.bankLabelHidden(
                      _vm.payment.creditorBankAccount,
                      _vm.payment.creditorZoneCode
                    ),
                    function (accountData) {
                      return [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              key: accountData.hiddenValue,
                              attrs: {
                                inputLabel:
                                  _vm.payment.direction === "1"
                                    ? _vm.$t(accountData.labelId + "_creditor")
                                    : _vm.$t(accountData.labelId + "_my"),
                                inputValue: accountData.hiddenValue,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.bankLabelHidden(
                      _vm.payment.debtorBankAccount,
                      _vm.payment.debtorZoneCode
                    ),
                    function (debtorAccountData) {
                      return [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              key: debtorAccountData.hiddenValue,
                              attrs: {
                                inputLabel:
                                  _vm.payment.direction === "0"
                                    ? _vm.$t(
                                        debtorAccountData.labelId + "_debtor"
                                      )
                                    : _vm.$t(debtorAccountData.labelId + "_my"),
                                inputValue: debtorAccountData.hiddenValue,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    }
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: "Date de création du paiement",
                          inputValue: _vm._f("formatDate")(
                            _vm.payment.creationDate
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.status.status_label"),
                          inputValue: _vm.getStatusLabel(
                            _vm.payment.status,
                            _vm.payment.direction
                          ),
                          statusIcon: _vm.getIcon(_vm.payment.status, "0"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.total_amount_no_currency"),
                          inputValue:
                            _vm.payment.amount +
                            " " +
                            _vm.getCurrencyIcon(_vm.payment.currency),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: "Date d'exécution",
                          inputValue: _vm._f("formatDate")(
                            _vm.payment.requestedExecutionDate
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.payment.attachmentId !== ""
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _vm.ifAndroid
                            ? _c(
                                "button",
                                {
                                  staticClass: "button-action milkyBlockButton",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.payment.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-paperclip",
                                  }),
                                  _vm._v(
                                    "\r\n          " +
                                      _vm._s(
                                        _vm.$t("creation_forms.view_attchmnt")
                                      ) +
                                      "\r\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.ifAndroid
                            ? _c(
                                "button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  attrs: { round: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(_vm.payment.attachmentId)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-paperclip",
                                  }),
                                  _vm._v(
                                    "\r\n            " +
                                      _vm._s(
                                        _vm.$t("creation_forms.dwnld_attchmnt")
                                      ) +
                                      "\r\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              [_vm.status.MADE, _vm.status.INST_MADE].includes(
                _vm.payment.status
              )
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "transactionDetailSubHeader",
                          attrs: { cols: "12" },
                        },
                        [
                          _vm._v(
                            "\r\n        " + _vm._s("Lettrage") + "\r\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-2", attrs: { cols: "12" } },
                        [
                          _vm._v(
                            "\r\n        " +
                              _vm._s(
                                _vm.payment.lettrage &&
                                  _vm.payment.lettrage.length > 0
                                  ? _vm.formatLettrage(_vm.payment.lettrage)
                                  : "Pas de lettrage"
                              ) +
                              "\r\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMainDetails ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.payment.history.length > 0
        ? _c(
            "form-accordion",
            {
              attrs: { title: _vm.$t("common.formsSubTitle.dir_pymnt_hstry") },
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-group row col-sm-6",
                  attrs: { id: "inst-payment-opt" },
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        value: "1",
                        "unchecked-value": "0",
                        disabled: "",
                      },
                      model: {
                        value: _vm.payment.instantPayment,
                        callback: function ($$v) {
                          _vm.$set(_vm.payment, "instantPayment", $$v)
                        },
                        expression: "payment.instantPayment",
                      },
                    },
                    [
                      _vm._v(
                        "\r\n        " +
                          _vm._s(_vm.$t("requestToPay.is_inst_payment")) +
                          "\r\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-striped table-bordered table-status-history",
                    },
                    [
                      _c("thead", { staticClass: "thead-dark" }, [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "reponsiveColumnWidth",
                              attrs: { scope: "col" },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.date_label")))]
                          ),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("common.status.status_label"))
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.payment.history, function (record) {
                          return _c("tr", { key: record.id }, [
                            _c("td", { staticClass: "dateTimehistoryHeight" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateTime")(record.creationDate)
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-sm-7 statusHistoryLabel",
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                    " +
                                        _vm._s(
                                          _vm.getStatusLabel(
                                            record.status,
                                            _vm.payment.direction
                                          )
                                        ) +
                                        "\r\n                    "
                                    ),
                                    _c("i", {
                                      class:
                                        "icon icon-transaction-detail " +
                                        _vm.getIcon(record.status),
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-5" },
                                  [
                                    _vm.showPain001View(record)
                                      ? _c(
                                          "f7-button",
                                          {
                                            staticClass: "xmlButtonBackground",
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewXML()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.button_technical_details"
                                                  )
                                                ) +
                                                "\r\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }